module.exports = __webpack_public_path__ + "img/vervaardiging.58fe2c00.jpg";